import { is } from 'bpmn-js/lib/util/ModelUtil';

/**
 * @param {any} semantic
 */
export function getLabelAttr(semantic) {
    if (
        is(semantic, 'bpmn:FlowElement') ||
        is(semantic, 'bpmn:Participant') ||
        is(semantic, 'bpmn:Lane') ||
        is(semantic, 'bpmn:SequenceFlow') ||
        is(semantic, 'bpmn:MessageFlow') ||
        is(semantic, 'bpmn:DataInput') ||
        is(semantic, 'bpmn:DataOutput')
    ) {
        return 'name';
    }

    if (is(semantic, 'bpmn:TextAnnotation')) {
        return 'text';
    }

    if (is(semantic, 'bpmn:Group')) {
        return 'categoryValueRef';
    }

    return undefined;
}
